<template>
    <div class="aside-item" @click.stop="goto" :class="className" @mouseenter="thumbtack=true"
         @mouseleave="thumbtack=false">
        <el-tooltip v-if="icon && collapsed" placement="right" :content="title">
            <component style="height: 20px;vertical-align: middle" :is="icon"></component>
        </el-tooltip>
        <component style="height: 20px;vertical-align: middle" :is="icon" v-else-if="icon"></component>
        <span v-else style="margin: 0 28px"></span>
        <span v-if="!collapsed">{{ title }}</span>
    </div>
</template>

<script>
export default {
    name: "AsideItem",
    props: {
        index: String,
        icon: String,
        disabled: Boolean,
        fixed: Boolean,
        title: String,
        routeQuery: {type: Object, default: null},
        unfixable: Boolean,
        defaultCollapsed: Boolean,
    },
    inject: ['parentDisabled', 'collapsed', 'collapse'],
    data() {
        return {
            thumbtack: false,
        }
    },
    computed: {
        className() {
            let class_name = '';
            if (this.is_route_active()) {
                class_name += 'is-active ';
            } else {
                class_name += 'normal ';
            }
            if (this.disabled || this.parentDisabled) {
                class_name += 'disabled '
            }
            return class_name;
        }
    },
    methods: {
        is_route_active() {
            if (!this.index || this.$route.name !== this.index) {
                return false;
            }
            const route_query = this.routeQuery || {};
            const route_keys = Object.keys(route_query);
            if (!route_keys.length) {
                return !Object.keys(this.$route.query || {}).length;
            }
            return route_keys.every(key => String(this.$route.query[key] || '') === String(route_query[key]));
        },
        goto() {
            if (this.disabled || this.parentDisabled)
                return
            if (this.index) {
                this.$router.push({
                    name: this.index,
                    query: this.routeQuery ? {...this.routeQuery} : {},
                });
            }
        },
    },
    watch: {
        $route() {
            if (this.index && this.index === this.$route.name) {
                if (this.defaultCollapsed) {
                    this.collapse();
                }
            }
        }
    }
}
</script>

<style scoped>
.aside-item {
    font-size: 14px;
    color: var(--el-text-color-regular);
    padding-left: 4px;
    border-top-right-radius: 45px;
    border-bottom-right-radius: 45px;
    white-space: nowrap;
    line-height: 40px;
}

.aside-item svg {
    margin: 0 18px;
}

.aside-item:hover {
    background-color: var(--el-border-color-light);
    cursor: pointer;
    color: var(--el-text-color-primary);
}

.aside-item.disabled {
    cursor: not-allowed;
    color: var(--el-text-color-placeholder);
}

.aside-item.is-active {
    background-color: var(--el-border-color-lighter);
    color: var(--el-color-primary);
}

.aside-item.normal {
}
</style>
<style>
html.dark .aside-item:hover {
    background-color: var(--el-fill-color-light);
}

html.dark .aside-item.is-active {
    background-color: var(--el-fill-color);
    color: var(--el-color-primary);
}
</style>
